var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGoogle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.91124 14.5027L5.10913 17.6213L2.17743 17.6859C1.30129 15.9934 0.804321 14.057 0.804321 11.9992C0.804321 10.0093 1.26897 8.13277 2.0926 6.48047H2.09323L4.70326 6.97884L5.84661 9.68091C5.60731 10.4075 5.47688 11.1875 5.47688 11.9992C5.47697 12.88 5.63018 13.724 5.91124 14.5027Z",
    fill: "#FBBB00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.6465 9.75781C23.7788 10.4837 23.8478 11.2334 23.8478 11.9996C23.8478 12.8587 23.7611 13.6967 23.5958 14.5051C23.035 17.2558 21.5694 19.6578 19.5392 21.3576L19.5386 21.3569L16.2511 21.1822L15.7858 18.1572C17.133 17.3343 18.1858 16.0466 18.7403 14.5051H12.5793V9.75781H18.8302H23.6465Z",
    fill: "#518EF8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.5386 21.3577L19.5392 21.3584C17.5647 23.0113 15.0565 24.0004 12.3261 24.0004C7.93836 24.0004 4.12354 21.4461 2.17749 17.6872L5.9113 14.5039C6.8843 17.2085 9.38933 19.1338 12.3261 19.1338C13.5884 19.1338 14.771 18.7784 15.7858 18.158L19.5386 21.3577Z",
    fill: "#28B446"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.6804 2.76262L15.9479 5.94525C14.8976 5.26153 13.6562 4.86656 12.3261 4.86656C9.32286 4.86656 6.77097 6.88017 5.84671 9.68175L2.09328 6.48131H2.09265C4.01021 2.63077 7.87314 0 12.3261 0C15.1217 0 17.685 1.03716 19.6804 2.76262Z",
    fill: "#F14336"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 23.0435,
    height: 24,
    fill: "white",
    transform: "translate(0.804321)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/google.b00719517059ce00610127e6f9b5b852.svg";
export { ForwardRef as ReactComponent };